import Request from './request';

const normalizeResponse = res => ({
  ...res,
  status: res && res.success ? 1 : 0,
});

export const apiGetPackages = () =>
  Request.call({ url: '/company/packages', method: 'GET' }).then(
    normalizeResponse
  );
